import DownloadCard from '@stories/Components/Cards/DownloadCard/DownloadCard';
import * as React from 'react';
import S from './Downloads.styles';
const Downloads = (props) => {
    return (React.createElement(S.Container, { variant: props.variant ?? 'light', flush: props.flush },
        React.createElement(S.Grid, null,
            props.title && React.createElement(S.Title, null, props.title),
            React.createElement(S.CardList, null, props.downloadList.map((card, i) => (React.createElement(DownloadCard, { key: `career-listing-${i}`, ...card })))))));
};
export default Downloads;
